import { FormAtylBase } from '../../form-atyl-base'

export class AtylDropdown extends FormAtylBase<string> {
	controlType = 'dropdown'
	type: string
	options: { key: string, value: string }[] = [];

	constructor(options: {} = {}) {
		super(options)
		this.type = options['type'] || []
		this.options = options['options'] || []
	}
}
